import React, { useEffect, useRef, useState } from 'react';

const MessageList = ({ messages }) => {
  const messagesEndRef = useRef(null);
  const [displayMessages, setDisplayMessages] = useState([]);

  useEffect(() => {
    // Update displayMessages when messages prop changes
    // Use an empty array if messages is null
    setDisplayMessages(messages || []);
  }, [messages]);

  useEffect(() => {
    // Scroll to bottom when messages change
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [displayMessages]);

  return (
    <div className="message-list" style={styles.messageList}>
      {displayMessages.map((message, index) => (
        <div
          key={index}
          className={`message ${message.role}`}
          style={message.role === 'user' ? styles.userMessage : styles.agentMessage}
        >
          <strong>{message.role === 'user' ? 'You' : 'Juno'}:</strong> {message.content}
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
};

const styles = {
  messageList: {
    height: '300px',
    overflowY: 'auto',
    padding: '10px',
    borderRadius: '5px',
  },
  userMessage: {
    backgroundColor: '#e6f3ff',
    padding: '5px 10px',
    margin: '5px 0',
    borderRadius: '10px',
    alignSelf: 'flex-end',
  },
  agentMessage: {
    backgroundColor: '#f0f0f0',
    padding: '5px 10px',
    margin: '5px 0',
    borderRadius: '10px',
    alignSelf: 'flex-start',
  },
};

export default MessageList;